export { default as HappinessSubmitter } from "./HappinessSubmitter";



// WEBPACK FOOTER //
// ./src/modules/diary/components/happinessSubmitter/index.js